import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App/App';
import './assets/css/styles.css';

ReactDOM.render(<App />, document.getElementById('root'));
